import { Typography } from "@mui/material"
import TextField, { TextFieldProps, TextFieldVariants } from "@mui/material/TextField"

const MuiTextField = <Variant extends TextFieldVariants>(
    props: {
        variant?: Variant
        errorText?: string
        size?: "small" | "medium" | "large"
    } & Omit<TextFieldProps, "variant" | "size">
) => {
    const { errorText, error, sx = {}, size = "small", multiline, ...rest } = props

    return (
        <>
            <TextField
                // large size is not supported in MUI, so we use medium instead
                size={size === "large" ? "medium" : size}
                variant="standard"
                multiline={multiline}
                sx={{
                    border: error ? "1px solid #F94054" : undefined,
                    ".Mui-disabled:before": {
                        borderBottom: "none !important",
                    },
                    ...(size === "large" && !multiline
                        ? {
                              height: "44px",
                              paddingInline: "8px",
                              "& .MuiInputBase-root": {
                                  height: "100%",
                              },
                          }
                        : {}),
                    ...(multiline
                        ? {
                              "& .MuiInputBase-root": {
                                  padding: "8px",
                                  fontSize: "12px",
                                  color: "#70758D",
                              },
                          }
                        : {}),
                    ...sx,
                }}
                {...rest}
            />
            {errorText && (
                <Typography variant="caption" sx={{ color: "#F94054", mt: 0.5, display: "block" }}>
                    {errorText}
                </Typography>
            )}
        </>
    )
}

export default MuiTextField
